<template>
  <div class="tabsDashboard">
    <vue-scroll :ops="ops">
      <div class="tabsDashboard__header">
        <div class="tabsDashboard__title">Customize your dashboard</div>
        <div class="tabsDashboard__text">
          <span class="text text--desktop">You can put any desired tab on the dashboard. Just drag it from the left vertical menu</span>
          <span class="text text--mobile">You can put any desired tab on the dashboard. “ADD NEW TAB” at the bottom of the page</span>
        </div>
      </div>
      <ul class="tabsDashboard__content js-tab-list">
        <div style="display:none;">
          <TabsDashboardProfile :type="'analytics'" :visible="sections.profile" @hideSection="hideSection"/>
          <TabsDashboardSettings :dashboardType="'analytics'" :visible="sections.settings" @hideSection="hideSection"/>
        </div>
        <TabsDashboardAdd :type="'analytics'" @showSection="showSection"/>
      </ul>
    </vue-scroll>
  </div>
</template>

<script>
  import TabsDashboardProfile from '@/components/dashboard/tabs/TabsDashboardProfile'
  import TabsDashboardSettings from '@/components/dashboard/tabs/TabsDashboardSettings'
  import TabsDashboardAdd from '@/components/dashboard/tabs/TabsDashboardAdd'
  import '@/views/dashboard/TabsDashboard.styl'

  export default {
    name: 'DashboardAnalytics',
    data: () => ({
      ops: {
        rail: {
          size: '3px',
        },
        bar: {
          size: '3px',
          background: 'rgba(0,0,0,0.1)',
        },
      },
      sections: {
        profile: true,
        settings: true,
        litquiditySignUps: true,
      },
    }),
    methods: {
      hideSection (value) {
        this.sections[`${value}`] = false
      },
      showSection (value) {
        this.sections[`${value}`] = true
      },
    },
    components: {
      TabsDashboardProfile,
      TabsDashboardSettings,
      TabsDashboardAdd,
    },
  }
</script>
